import React, { useEffect, useState, useContext } from "react";
import { useLocation } from "react-router-dom";
import {
  Tabs,
  Tab,
  Spinner,
  Card,
  Row,
  Col,
  Badge,
  Button,
  Table
} from "react-bootstrap";
import AppContext from "../../Context/AppContext";
import apis from "../../services/apis";
import { toast } from "react-toastify";
import apiCommonParams from "../../constants/apiCommonParams";
import { useHistory } from "react-router-dom";
import './assignRoles.css';


const AssignRole = () => {
  const location = useLocation();
  const history = useHistory();
  const queryParams = new URLSearchParams(location.search);
  const projectId = queryParams.get("p");
  const projectPermissions =
  JSON.parse(localStorage.getItem("projectPermissions")) || {};

const isGlobalAdmin =
  JSON.parse(localStorage.getItem("isGlobalAdmin")) || false;

const hasMPPermission =
  projectId &&
  projectPermissions[projectId]?.includes("MP");

  const [projectName, setProjectName] = useState(() => {
  if (location.state?.projectName) return location.state.projectName;

  const storedProject = localStorage.getItem("selectedProject");
  if (storedProject) {
    try {
      const parsed = JSON.parse(storedProject);
      return parsed.projectName || "";
    } catch {
      return "";
    }
  }
  return "";
});


  const { applicationId, siteId } = useContext(AppContext);
  const moduleId = 189;

  const [roles, setRoles] = useState([]);
  const [activeRoleId, setActiveRoleId] = useState(null);
  const [loading, setLoading] = useState(false);

  // ROLE-WISE STORAGE
  const [assignedUsersByRole, setAssignedUsersByRole] = useState({});
  const [assignedGroupsByRole, setAssignedGroupsByRole] = useState({});

  // USER SEARCH STATE
  const [userSearchKeyword, setUserSearchKeyword] = useState("");
  const [searchedUsers, setSearchedUsers] = useState([]);
  const [searchingUsers, setSearchingUsers] = useState(false);

  // Selected users per role
  const [selectedUsersByRole, setSelectedUsersByRole] = useState({});
  const [assigningPM, setAssigningPM] = useState(false);
  const [removingUserId, setRemovingUserId] = useState(null);
  // ===== GROUPS =====
const [allGroups, setAllGroups] = useState([]);
// ROLE → PERMISSIONS (with description)
const [permissionsByRole, setPermissionsByRole] = useState({});


const [selectedGroupsByRole, setSelectedGroupsByRole] = useState({});
const [assigningGroup, setAssigningGroup] = useState(false);
const [removingGroupId, setRemovingGroupId] = useState(null);


const [groupPageByRole, setGroupPageByRole] = useState({});
const groupsPerPage = 10;



  const storedToken = localStorage.getItem("keycloakToken");
useEffect(() => {
  if (projectId && projectName) {
    localStorage.setItem(
      "selectedProject",
      JSON.stringify({ projectId, projectName })
    );
  }
}, [projectId, projectName]);

useEffect(() => {
  if (activeRoleId && !permissionsByRole[activeRoleId]) {
    loadRolePermissions(activeRoleId);
  }
}, [activeRoleId]);

useEffect(() => {
  
  if (!projectId) {
    history.replace("/dashboard");
    return;
  }

  
  if (!isGlobalAdmin && !hasMPPermission) {
    history.replace(`/dashboard?p=${projectId}`);
    toast.error("You are not authorized to access the project members and roles.");
  }
}, [projectId, isGlobalAdmin, hasMPPermission, history]);

useEffect(() => {
  if (!projectName && projectId) {
    const storedProject = localStorage.getItem("selectedProject");
    if (storedProject) {
      try {
        const parsed = JSON.parse(storedProject);
        if (String(parsed.projectId) === String(projectId)) {
          setProjectName(parsed.projectName || "");
        }
      } catch {}
    }
  }
}, [projectId, projectName]);

useEffect(() => {
  if (projectId && !projectName && applicationId && siteId) {
    loadProjectDetails();
  }
}, [projectId, projectName, applicationId, siteId]);

const loadProjectDetails = async () => {
  try {
    const res = await apis.getProjectById(
      applicationId,
      siteId,
      projectId,
      storedToken
    );

    if (res?.project?.projectName) {
      setProjectName(res.project.projectName);

      localStorage.setItem(
        "selectedProject",
        JSON.stringify({
          projectId,
          projectName: res.project.projectName
        })
      );
    }
  } catch (err) {
    console.error("Failed to load project details", err);
  }
};



const goBackToDashboard = () => {
  localStorage.removeItem("selectedProject");
  history.push(`/dashboard?p=${projectId}`);
};

  /* ================= LOAD ROLES ================= */
  const loadRoles = async () => {
    setLoading(true);
    try {
      const roleList = await apis.getRolesList(
        { applicationId, siteId, moduleId },
        storedToken
      );

      const sortedRoles = (roleList || []).sort(
        (a, b) => a.roleLevel - b.roleLevel
      );

      setRoles(sortedRoles);
      if (sortedRoles.length) {
        setActiveRoleId(sortedRoles[0].roleId);
      }
    } catch (err) {
      console.error("Failed to load roles", err);
    } finally {
      setLoading(false);
    }
  };

  const loadRolePermissions = async (roleId) => {
  try {
    const res = await apis.getAssignedPermissions(
      applicationId,
      siteId,
      roleId,
      storedToken
    );

    if (!res?.json) return;

    const parsed = JSON.parse(res.json);

    const permissionList =
      parsed.permissionTOList?.map(p => ({
        code: p.permission,
        desc: p.permissionDesc
      })) || [];

    setPermissionsByRole(prev => ({
      ...prev,
      [roleId]: permissionList
    }));
  } catch (err) {
    console.error("Failed to load permissions", err);
  }
};

const getGroupPage = roleId => groupPageByRole[roleId] || 1;

const setGroupPage = (roleId, page) => {
  setGroupPageByRole(prev => ({ ...prev, [roleId]: page }));
};

  /* ================= LOAD ASSIGNED USERS & GROUPS ================= */
const loadAssignedUsersAndGroups = async () => {
  try {
    const response = await apis.getAssignedUsersAndGroups(applicationId, siteId,projectId, storedToken);
    const parsed = response?.json ? JSON.parse(response.json) : {};

    const userRoles =
      parsed?.contentLevelUserRoleHBList?.contentLevelUserRoleHBs || [];

    const groupRoles =
      parsed?.contentLevelUserGroupRoleHBList
        ?.contentLevelUserGroupRoleHBList || [];

    const allGroupList =
      parsed?.contentLevelUserGroupHB?.userGroupList || [];

    const usersMap = {};
    const groupsMap = {};

    userRoles.forEach(item => {
      const roleId = item.roleTO.roleId;
      if (!usersMap[roleId]) usersMap[roleId] = [];
      usersMap[roleId].push({
        id: item.userTO.userId,
        name: `${item.userTO.firstName} ${item.userTO.lastName}`,
        username: item.userTO.username,
        email: item.userTO.email
      });
    });

    groupRoles.forEach(item => {
      const roleId = item.roleTO.roleId;
      if (!groupsMap[roleId]) groupsMap[roleId] = [];
      groupsMap[roleId].push({
        id: item.userGroupTO.groupId,
        name: item.userGroupTO.groupName
      });
    });

    setAssignedUsersByRole(usersMap);
    setAssignedGroupsByRole(groupsMap);

   setAllGroups(
  allGroupList.map(g => ({
    id: g.groupId,
    name: g.groupName
  }))
);
  } catch (err) {
    console.error("Failed to load assigned users/groups", err);
  }
};


  useEffect(() => {
    if (applicationId && siteId) loadRoles();
  }, [applicationId, siteId]);

  useEffect(() => {
    if (projectId) loadAssignedUsersAndGroups();
  }, [projectId]);

  /* ================= USER SEARCH HANDLERS ================= */
  const handleUserSearchChange = (e) => setUserSearchKeyword(e.target.value);

  const searchUsers = async () => {
    if (!userSearchKeyword || userSearchKeyword.length < 2) {
      toast.error("Please enter at least 2 characters");
      return;
    }

    try {
      setSearchingUsers(true);
      setSearchedUsers([]);
      const users = await apis.searchUsers(applicationId,userSearchKeyword, 20, 0, storedToken);

      // Filter out already assigned users for active role
      const assignedUserIds = assignedUsersByRole[activeRoleId]?.map(u => u.id) || [];
      const filteredUsers = (users || []).filter(u => !assignedUserIds.includes(u.userId));

      if (!filteredUsers.length) toast.info("No user found");

      setSearchedUsers(filteredUsers);
    } catch (err) {
      console.error(err);
      toast.error("Failed to search users");
    } finally {
      setSearchingUsers(false);
    }
  };

  const clearUserSearch = () => {
    setUserSearchKeyword("");
    setSearchedUsers([]);
  };

  const toggleUserSelection = (roleId, user) => {
    setSelectedUsersByRole(prev => {
      const selected = prev[roleId] || [];
      if (selected.some(u => u.userId === user.userId)) {
        return { ...prev, [roleId]: selected.filter(u => u.userId !== user.userId) };
      } else {
        return { ...prev, [roleId]: [...selected, user] };
      }
    });
  };
const toggleGroupSelection = (roleId, group) => {
  setSelectedGroupsByRole(prev => {
    const selected = prev[roleId] || [];

    if (selected.some(g => g.id === group.id)) {
      return {
        ...prev,
        [roleId]: selected.filter(g => g.id !== group.id)
      };
    }

    return {
      ...prev,
      [roleId]: [...selected, group]
    };
  });
};

  /* ================= ASSIGN USERS ================= */
  const assignSelectedUsers = async (roleId) => {
    const selectedUsers = selectedUsersByRole[roleId] || [];
    if (!selectedUsers.length || !projectId) return;

    try {
      setAssigningPM(true);

      for (const user of selectedUsers) {
        const alreadyAssigned = assignedUsersByRole[roleId]?.some(u => u.id === user.userId);
        if (alreadyAssigned) continue;

        const formData = new FormData();
        formData.append("applicationid", applicationId);
        formData.append("siteid", siteId);
        formData.append("userid", user.userId);
        formData.append("roleid", roleId);
        formData.append("moduleid", moduleId);
        formData.append("treeid", 0); // adjust if needed
        formData.append("entityid", projectId);
        formData.append("entitytype", "project");
        formData.append("swcmTicket", apiCommonParams.swcmTicket);

        await apis.assignProjectManagerRole(formData, storedToken);
      }

      toast.success("Selected users assigned successfully");

      // Clear selection and reload assigned users
      setSelectedUsersByRole(prev => ({ ...prev, [roleId]: [] }));
      await loadAssignedUsersAndGroups();
    } catch (err) {
      console.error(err);
      toast.error("Failed to assign users");
    } finally {
      setAssigningPM(false);
    }
  };
const removeUser = async (user, roleId) => {
  if (!user || !projectId) return;

  try {
    setRemovingUserId(user.id);

    const token = localStorage.getItem("keycloakToken");

    const formData = new FormData();
    formData.append("applicationid", applicationId);
    formData.append("siteid", siteId);
    formData.append("userid", user.id);
    formData.append("entityid", projectId);
    formData.append("entitytype", "project");
    formData.append("swcmTicket", apiCommonParams.swcmTicket);

    await apis.removeProjectManagerRole(formData, token);

    toast.success("User removed successfully");

    // Refresh assigned users table
    await loadAssignedUsersAndGroups();
  } catch (err) {
    console.error("Remove user error", err);
    toast.error("Failed to remove user");
  } finally {
    setRemovingUserId(null);
  }
};

const assignSelectedGroups = async (roleId) => {
  const selectedGroups = selectedGroupsByRole[roleId] || [];
  if (!selectedGroups.length || !projectId) return;

  try {
    setAssigningGroup(true);

    for (const group of selectedGroups) {
      const formData = new FormData();
      formData.append("applicationid", applicationId);
      formData.append("siteid", siteId);
      formData.append("groupid", group.id);
      formData.append("roleid", roleId);
      formData.append("moduleid", moduleId);
      formData.append("treeid", 0);
      formData.append("entityid", projectId);
      formData.append("entitytype", "project");
      formData.append("swcmTicket", apiCommonParams.swcmTicket);

      await apis.assignProjectManagerGroup(formData, storedToken);
    }

    toast.success("Groups assigned successfully");

    // ✅ RESET PAGE (THIS FIXES THE BUG)
    setGroupPage(roleId, 1);

    // Clear selection
    setSelectedGroupsByRole(prev => ({ ...prev, [roleId]: [] }));

    await loadAssignedUsersAndGroups();
  } catch (err) {
    toast.error("Failed to assign groups");
  } finally {
    setAssigningGroup(false);
  }
};


const removeGroup = async (group, roleId) => {
  try {
    setRemovingGroupId(group.id);

    const formData = new FormData();
    formData.append("applicationid", applicationId);
    formData.append("siteid", siteId);
    formData.append("groupid", group.id);
    formData.append("entityid", projectId);
    formData.append("entitytype", "project");
    formData.append("swcmTicket", apiCommonParams.swcmTicket);

    await apis.removeProjectManagerGroup(formData, storedToken);

    toast.success("Group removed successfully");
    await loadAssignedUsersAndGroups();
  } catch (err) {
    toast.error("Failed to remove group");
  } finally {
    setRemovingGroupId(null);
  }
};


if (!isGlobalAdmin && !hasMPPermission) {
  return null; 
}

  return (
  <div className="main-container">
   <div className="header-sections">
		<div className="container-fluid mt-3 pb-5">
		  {/* PAGE HEADER (same style as Roles Management) */}
		  <div className="d-flex justify-content-between align-items-start mb-3">
			<div>
				<h1 className="page-title mb-1">Manage Project Roles</h1>
				<p className="page-subtitle mb-1">
          Manage project roles, permissions, and user/group assignments
        </p>

				<div className="d-flex align-items-center gap-2">
					<strong>Project Name: {projectName || `Project #${projectId}`}</strong>
				</div>
			</div>

			<div>
			  <Button
				variant="link"
				className="me-2"
				onClick={goBackToDashboard}
			  >
				Back to Dashboard
			  </Button>
        
			</div>
		  </div>

		  {/* ROLE TABS */}
		  {loading ? (
			<div className="text-center p-4">
			  <Spinner animation="border" />
			</div>
		  ) : roles.length === 0 ? (
			<p className="text-muted text-center">No roles found</p>
		  ) : (
			<Tabs
        activeKey={activeRoleId}
        onSelect={(k) => setActiveRoleId(Number(k))}
        className="mb-3"
      >
			  {roles.map((role) => (
				<Tab
				  key={role.roleId}
				  eventKey={role.roleId}
				  title={`${role.roleName}`}
				>
				 <RoleTabContent
					role={role}
          permissions={permissionsByRole[role.roleId] || []}
					assignedUsers={assignedUsersByRole[role.roleId] || []}
					searchedUsers={searchedUsers}
					searchingUsers={searchingUsers}
					userSearchKeyword={userSearchKeyword}
					handleUserSearchChange={handleUserSearchChange}
					toggleGroupSelection={toggleGroupSelection}
					searchUsers={searchUsers}
					clearUserSearch={clearUserSearch}
					toggleUserSelection={toggleUserSelection}
					selectedUsers={selectedUsersByRole[role.roleId] || []}
					assignSelectedUsers={assignSelectedUsers}
					assigningPM={assigningPM}
					removeUser={removeUser}
					removingUserId={removingUserId}
					removingGroupId={removingGroupId}
					groups={assignedGroupsByRole[role.roleId] || []}
					allGroups={allGroups}
					selectedGroups={selectedGroupsByRole[role.roleId] || []}
					assignSelectedGroups={assignSelectedGroups}
					assigningGroup={assigningGroup}
					removeGroup={removeGroup}
					getGroupPage={getGroupPage}
					setGroupPage={setGroupPage}
					groupsPerPage={groupsPerPage}
					/>

				</Tab>
			  ))}
			</Tabs>
		  )}
		</div>
	</div>
</div>
  );
};

/* ================= ROLE TAB CONTENT ================= */
const RoleTabContent = ({
  role,
  permissions,
  assignedUsers,
  searchedUsers,
  searchingUsers,
  userSearchKeyword,
  handleUserSearchChange,
  searchUsers,
  clearUserSearch,
  toggleUserSelection,
  selectedUsers,
  assignSelectedUsers,
  assigningPM,
  removeUser,
  removingUserId,
  removingGroupId,
  groups,
  allGroups,
  selectedGroups,
  toggleGroupSelection,
  assignSelectedGroups,
  assigningGroup,
  removeGroup,
  getGroupPage,
  setGroupPage,
  groupsPerPage
}) => 
 {
  const [activeAssignTab, setActiveAssignTab] = useState("users");
const assignedGroupIds = groups.map(g => g.id);

const availableGroups = allGroups.filter(
  g => !assignedGroupIds.includes(g.id)
);
const page = getGroupPage(role.roleId);

const totalPages = Math.max(
  1,
  Math.ceil(availableGroups.length / groupsPerPage)
);

const safePage = Math.min(page, totalPages);

const paginatedGroups = availableGroups.slice(
  (safePage - 1) * groupsPerPage,
  safePage * groupsPerPage
);




  return (
    <Row className="mt-3">
      <Col md={4}>
      <Card className="mb-3">
          <Card.Header><strong>Role Details</strong></Card.Header>
         <Card.Body>
            <p><b>Name:</b> {role.roleName}</p>
            <p><b>Level:</b> {role.roleLevel}</p>

            <p className="mt-3 mb-1"><b>Assigned Permissions</b></p>

            {permissions.length === 0 ? (
              <span className="text-muted">No permissions assigned</span>
            ) : (
              <div>
                {permissions.map(p => (
                  <div key={p.code} className="mb-1">
                    
                    <span>{p.desc}</span>
                  </div>
                ))}
              </div>
            )}
          </Card.Body>

        </Card>



      </Col>

      <Col md={8}>
        <Card>
          <Card.Header><strong>User / Group Assignment</strong></Card.Header>
          <Card.Body>
            <Tabs
              activeKey={activeAssignTab}
              onSelect={(k) => setActiveAssignTab(k)}
              className="mb-3"
            >
              <Tab eventKey="users" title="Users">
                {/* USERS TAB */}
                <h6>Search Users</h6>
                <div className="search-bx d-flex">
                <input
                            type="text"
                            className="form-control"
                            placeholder="Search user by name or email"
                            value={userSearchKeyword}
                            onChange={handleUserSearchChange}
                          />
                
                          <Button variant="primary" className="m-2" disabled={searchingUsers} onClick={searchUsers}>
                                      {searchingUsers ? "Searching..." : "Search"}
                          </Button>
                <Button variant="secondary" onClick={clearUserSearch}>
                            Clear
                </Button>
                </div>
              


                {searchedUsers.length > 0 && (
                  <>
                    <h6 className="mt-3">Search Results</h6>
                    <Table bordered hover size="sm">
                      <thead>
                        <tr>
                          <th>ID</th><th>Name</th><th>Username</th><th>Email</th><th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {searchedUsers.map(u => (
                          <tr key={u.userId}>
                            <td>{u.userId}</td>
                            <td>{u.firstName} {u.lastName}</td>
                            <td>{u.username}</td>
                            <td>{u.email}</td>
                            <td>
                              <input
                                type="checkbox"
                                checked={selectedUsers.some(s => s.userId === u.userId)}
                                onChange={() => toggleUserSelection(role.roleId, u)}
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                    <Button
                          variant="success"
                          size="sm"
                          className="mt-2"
                          disabled={!selectedUsers.length || assigningPM}
                        onClick={() => assignSelectedUsers(role.roleId)}
                    >
                      {assigningPM ? "Assigning..." : "Assign Selected"}
                    </Button>
                  </>
                )}

                <h6 className="fw-semibold mt-4">Assigned Users</h6>
                <Table bordered hover size="sm">
                  <thead>
                    <tr>
                      <th>ID</th><th>Name</th><th>Username</th><th>Email</th><th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {assignedUsers.length === 0 ? (
                      <tr><td colSpan="5" className="text-center text-muted py-4">
                          No users assigned to this role
                        </td></tr>
                    ) : (
                      assignedUsers.map(u => (
                        <tr key={u.id}>
                          <td>{u.id}</td>
                          <td>{u.name}</td>
                          <td>{u.username}</td>
                          <td>{u.email}</td>
                          <td>
                            <Button
                                variant="danger"
                                size="sm"
                                disabled={removingUserId === u.id}
                                onClick={() => removeUser(u, role.roleId)}
                                >
                                {removingUserId === u.id ? "Removing..." : "Remove"}
                                </Button>


                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </Table>
              </Tab>

              <Tab eventKey="groups" title="Groups">
  <h6 className="fw-semibold">Available Groups</h6>


  <Table bordered hover size="sm">
    <thead>
      <tr>
        <th>ID</th>
        <th>Group Name</th>
        <th className="text-center">Select</th>
      </tr>
    </thead>
    <tbody>
      {paginatedGroups.length === 0 ? (
        <tr>
          <td colSpan="3" className="text-center text-muted">
            No groups available
          </td>
        </tr>
      ) : (
        paginatedGroups.map(g => (
          <tr key={g.id}>
            <td>{g.id}</td>
            <td>{g.name}</td>
            <td className="text-center">
              <input
                type="checkbox"
                checked={selectedGroups.some(sg => sg.id === g.id)}

                onChange={() => toggleGroupSelection(role.roleId, g)}
              />
            </td>
          </tr>
        ))
      )}
    </tbody>
  </Table>

  {/* PAGINATION */}
  {totalPages > 1 && (
    <div className="d-flex justify-content-center gap-2 mt-2">
      <Button
        size="sm"
        disabled={page === 1}
        onClick={() => setGroupPage(role.roleId, page - 1)}
      >
        Prev
      </Button>

      <span className="pt-1">
        Page {page} of {totalPages}
      </span>

      <Button
        size="sm"
        disabled={page === totalPages}
        onClick={() => setGroupPage(role.roleId, page + 1)}
      >
        Next
      </Button>
    </div>
  )}

  <Button
  className="mt-3"
  variant="primary"
  disabled={!selectedGroups.length || assigningGroup}
  onClick={() => assignSelectedGroups(role.roleId)}
>
  {assigningGroup ? "Assigning..." : "Assign Selected"}
</Button>



  <h6 className="fw-semibold mt-4">Assigned Groups</h6>

  <Table bordered hover size="sm">
    <tbody>
      {groups.length === 0 ? (
        <tr>
          <td colSpan="3" className="text-center text-muted">
            No groups assigned
          </td>
        </tr>
      ) : (
        groups.map(g => (
          <tr key={g.id}>
            <td>{g.id}</td>
            <td>{g.name}</td>
            <td>
              <Button
              size="sm"
              variant="danger"
              disabled={removingGroupId === g.id}
              onClick={() => removeGroup(g, role.roleId)}
            >
              {removingGroupId === g.id ? "Removing..." : "Remove"}
            </Button>

            </td>
          </tr>
        ))
      )}
    </tbody>
  </Table>
</Tab>

            </Tabs>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};


export default AssignRole;